export default {
  styleOverrides: {
    root: {
      "&.Mui-selected, &.Mui-selected:hover": {
        backgroundColor: "rgba(77, 125, 242, 0.3)",
      },
    },
  },
};